import React from 'react';
import PropTypes from 'prop-types';
import LEO from '../components/LEO';

function LEOTemplate({ uri, description, isEmbed, stateLinks }) {
  return (
    <LEO
      uri={uri}
      description={description}
      successPage='donate'
      isEmbed={isEmbed}
      stateLinks={stateLinks}
    />
  );
}

LEOTemplate.propTypes = {
  uri: PropTypes.string.isRequired,
  description: PropTypes.string,
  isEmbed: PropTypes.bool,
  stateLinks: PropTypes.object,
};

export default LEOTemplate;
